module.exports = __webpack_public_path__ + "static/media/red_cross.07609446.jpg";